// YourReGen brand wordmark — approved: "Your" in cyan, "ReGen" in navy (foreground), with the circular-R mark.
export function RegenLogo({ size = 'md', className = '', withIcon = false }) {
  const sizes = { sm: 'text-xl', md: 'text-3xl', lg: 'text-4xl', xl: 'text-6xl' };
  const icon = { sm: 'w-7 h-7', md: 'w-9 h-9', lg: 'w-11 h-11', xl: 'w-16 h-16' };
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {withIcon && <img src="/icon-512.png" alt="YourReGen" className={`${icon[size]} rounded-[22%] select-none`} draggable="false" />}
      <div className={`font-display font-black tracking-tight ${sizes[size]} select-none leading-none`}>
        <span className="text-[#00C8FF]">Your</span><span className="text-foreground">ReGen</span>
      </div>
    </div>
  );
}
